import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckoutSuccessComponent } from '../protected/checkout-success/checkout-success.component';
import { FreePlanComponent } from '../protected/free-plan/free-plan.component';
import { StripePaymentComponent } from '../protected/stripe-payment/stripe-payment.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { FullscreenTimerComponent } from './fullscreen-timer/fullscreen-timer.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ThanksComponent } from './thanks/thanks.component';
import { UserloginComponent } from './userlogin/userlogin.component';
import { UserRegistrationComponent } from './userRegistration/userRegistration.component';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import { InstantTimerComponent } from './instant-timer/instant-timer.component';

// Routes for child Module (publicModule). Since public module is lazy loaded in in the 
// app-routing.module the full path is `/public/login` or `/public/regiser`
const routes: Routes = [
  {
    path: '',
    component: UserloginComponent
  },
  {
    path: 'login',
    component: UserloginComponent
  },
  {
    path: 'instant-timer/:frequency',
    component: InstantTimerComponent
  },
  {
    path: 'register',
    component: UserRegistrationComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'thank-you',
    component: ThanksComponent
  },
  {
    path: 'timer/:timerid',
    component: FullscreenTimerComponent
  },
  {
    path: 'payment/:plan',
    component: StripePaymentComponent
  },
  {
    path: 'free-payment/:plan',
    component: FreePlanComponent
  },
  {
    path: 'checkout_success',
    component: CheckoutSuccessComponent
  },
  {
    path: 'verify-otp/:code/:mfa',
    component: VerifyOtpComponent
  },
  {
    path: 'reset-password/:code',
    component: ResetPasswordComponent
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule { }
